var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogofishlogsm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 26,
    viewBox: "0 0 102 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_924)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1937 20.5895C42.5585 20.5895 43.6359 21.6669 43.6359 22.9957C43.6359 24.3245 42.5225 25.4019 41.1937 25.4019C39.829 25.4019 38.7516 24.3245 38.7516 22.9957C38.7157 21.6669 39.829 20.5895 41.1937 20.5895ZM50.9983 19.3684C52.6862 19.3684 54.015 20.6972 54.015 22.3492C54.015 24.0013 52.6503 25.3301 50.9983 25.3301C49.3462 25.3301 47.9815 24.0013 47.9815 22.3492C47.9815 20.6972 49.3103 19.3684 50.9983 19.3684ZM54.5537 21.0563H64.5378L65.9385 17.0699H59.0071V1.08813H54.5537V21.0563ZM43.3845 20.4817V12.5088C43.3845 10.4617 44.4619 9.38427 46.1499 9.38427C47.8378 9.38427 48.8075 10.4258 48.8075 12.5088V18.9733C49.454 18.5783 50.2081 18.3269 50.9983 18.3269C51.8243 18.3269 52.5785 18.5783 53.189 18.9733V11.1441C53.189 7.62449 51.2497 5.46965 47.9097 5.46965C45.683 5.46965 44.3901 6.65481 43.3486 7.9118V0.226196H38.9311V20.4817C39.5058 19.9789 40.2959 19.6916 41.1219 19.6916C42.0198 19.6916 42.7739 19.9789 43.3845 20.4817Z",
    fill: "#EBB105"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 21.0565H4.45334V13.3349H14.1501V9.31257H4.45334V5.07471H15.443V1.08826H0V21.0565Z",
    fill: "#15387B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7419 4.069H22.3748V0.226196H17.7419V4.069ZM17.8856 21.0563H22.2671V5.75696H17.8856V21.0563Z",
    fill: "#15387B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9578 21.343C34.3337 21.343 36.8836 19.7987 36.8836 16.4228V16.351C36.8836 13.5497 34.3696 12.5441 32.1789 11.8258C30.4909 11.2512 29.0185 10.8561 29.0185 9.99421V9.92238C29.0185 9.31184 29.5572 8.88087 30.6346 8.88087C31.7479 8.88087 33.2922 9.41958 34.8365 10.3174L36.5245 7.33657C34.8365 6.22323 32.7176 5.57678 30.7423 5.57678C27.6178 5.57678 25.0679 7.30066 25.0679 10.4252V10.497C25.0679 13.4779 27.546 14.4475 29.7008 15.094C31.4247 15.5968 32.9331 15.92 32.9331 16.8538V16.9256C32.9331 17.608 32.3585 18.0749 31.0656 18.0749C29.629 18.0749 27.8333 17.4643 26.1813 16.2433L24.3137 19.0805C26.3608 20.6248 28.803 21.343 30.9578 21.343Z",
    fill: "#15387B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4559 21.3797C80.3043 21.3797 83.8957 17.8242 83.8957 13.4068V13.335C83.8957 8.95347 80.3402 5.4339 75.5277 5.4339C70.6793 5.4339 67.0879 8.98939 67.0879 13.4068V13.4786C67.0879 17.8961 70.6434 21.3797 75.4559 21.3797ZM75.4918 17.6447C73.0496 17.6447 71.3976 15.6694 71.3976 13.4068V13.335C71.3976 11.0724 72.906 9.16896 75.4199 9.16896C77.8621 9.16896 79.5141 11.1442 79.5141 13.4068V13.4786C79.5501 15.7412 78.0417 17.6447 75.4918 17.6447Z",
    fill: "#15387B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1614 25.6896C96.1782 25.6896 98.4049 25.079 99.8414 23.6425C101.134 22.3496 101.817 20.3743 101.817 17.6089V5.75728H97.3993V7.76847C96.2141 6.47556 94.7775 5.46997 92.4072 5.46997C88.8517 5.46997 85.5117 8.05578 85.5117 12.6169V12.6887C85.5117 17.2139 88.7799 19.8356 92.4072 19.8356C94.7416 19.8356 96.1782 18.9018 97.4711 17.3575V18.1117C97.4711 20.8412 96.0345 22.2777 93.0537 22.2777C91.0066 22.2777 89.3904 21.7749 87.8102 20.8771L86.3018 24.1453C88.2412 25.1149 90.6115 25.6896 93.1614 25.6896ZM93.6642 16.2083C91.5094 16.2083 89.8932 14.7717 89.8932 12.6528V12.5809C89.8932 10.4979 91.5094 9.02546 93.6642 9.02546C95.819 9.02546 97.4711 10.4979 97.4711 12.5809V12.6528C97.4711 14.7358 95.819 16.2083 93.6642 16.2083Z",
    fill: "#15387B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 25.5477,
    fill: "white",
    transform: "translate(0 0.226196)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogofishlogsm);
export default __webpack_public_path__ + "static/media/logo fishlog sm.178b21b233a85839a61be790acb49600.svg";
export { ForwardRef as ReactComponent };